<template>
    <div class="full-height">
        <a
            :href="linkHref"
            style="text-decoration: none"
            @click="handleLinkClick"
            class="full-height block"
        >
            <q-card
                color="primary"
                :class="[
                    'shiftBlock',
                    'full-height',
                    shift.statusText,
                    campaign.fastModeIsActive &&
                    shift.hasFreePlaces &&
                    !shift.isClosed
                        ? 'fastMode noLoadingOverlay'
                        : '',
                ]"
            >
                <q-card-section horizontal class="full-height">
                    <q-card-section>
                        <small>
                            <div>
                                {{ formatTime(shift.startDateTime) }}
                                {{ $window.translations["common.to"] || "bis" }}
                                <nobr>{{ formatTime(shift.endDateTime) }}</nobr>
                            </div>

                            <template
                                v-if="shift.hasFreePlaces && !shift.isClosed"
                            >
                                <br />
                                {{ shift.numberOfFreePlaces }}
                                {{
                                    shift.numberOfFreePlaces > 1
                                        ? $window.translations[
                                              "common.stats.free_slots_lowercase"
                                          ] || "freie Plätze"
                                        : $window.translations[
                                              "common.stats.free_slot"
                                          ] || "freier Platz"
                                }}
                            </template>
                            <template v-else>
                                <br /><br />{{
                                    $window.translations["occupied"] ||
                                    "Besetzt"
                                }}
                            </template>
                        </small>
                    </q-card-section>
                    <q-card-section
                        v-if="shift.hasViolations"
                        class="q-pt-none q-pb-xs"
                    >
                        <q-icon
                            name="warning"
                            color="warning"
                            size="sm"
                        ></q-icon>
                    </q-card-section>
                    <q-card-section
                        v-if="calendar.showParticipationsAtShiftBlocks"
                    >
                        <ol>
                            <li v-for="n in shift.numberOfShiftPlaces" :key="n">
                                <template
                                    v-if="
                                        shift.participations &&
                                        shift.participations[n - 1]
                                    "
                                >
                                    {{
                                        shift.participations[n - 1]
                                            .publisherText
                                    }}
                                </template>
                                <template v-else> ----- </template>
                            </li>
                        </ol>
                    </q-card-section>
                </q-card-section>
            </q-card>
        </a>

        <!-- Warning Modal -->
        <q-dialog v-model="modals.warning">
            <q-card>
                <q-card-section>
                    <div class="text-h6">
                        <strong>{{
                            $window.translations[
                                "notification.shift.new_participation"
                            ] || "Neue Schichtteilnahme"
                        }}</strong>
                    </div>
                </q-card-section>
                <q-card-section>
                    <q-banner class="bg-warning text-black q-mb-md">
                        {{
                            $window.translations[
                                "common.help.brother_sister_ratio_hint"
                            ] ||
                            "Hinweis zum Verhältnis von Brüdern und Schwestern"
                        }}
                    </q-banner>
                </q-card-section>
                <q-card-actions align="right">
                    <q-btn
                        flat
                        :label="$window.translations['close'] || 'Schließen'"
                        color="primary"
                        v-close-popup
                    ></q-btn>
                </q-card-actions>
            </q-card>
        </q-dialog>

        <!-- Fast Mode Modal -->
        <q-dialog v-model="modals.fastMode">
            <q-card>
                <q-card-section>
                    <div class="text-h6">
                        <strong>{{
                            $window.translations[
                                "notification.shift.new_participation"
                            ] || "Neue Schichtteilnahme"
                        }}</strong>
                    </div>
                </q-card-section>
                <q-card-section>
                    <p>{{ campaign.titleLong }}</p>
                    <p>
                        {{ formatDateTime(shift.startDateTime) }} -
                        {{ formatTime(shift.endDateTime) }}
                    </p>

                    <template v-if="shift.numberOfFreePlaces >= 1">
                        <template v-if="!shift.publisherIsAlreadyInShift">
                            <form method="POST" :action="participationPostUrl">
                                <input
                                    type="hidden"
                                    name="_token"
                                    :value="csrfToken"
                                />
                                <input
                                    type="hidden"
                                    name="shiftId"
                                    :value="shift.id"
                                />
                                <input
                                    type="hidden"
                                    name="user1Id"
                                    :value="user.publisherId"
                                />
                                <input
                                    type="hidden"
                                    name="submitGotoLastView"
                                    value="1"
                                />
                                <div class="row">
                                    <q-btn
                                        type="submit"
                                        :label="participationLabel"
                                        color="positive"
                                        class="col-12 q-mb-md"
                                        style="width: 100%"
                                    />
                                </div>
                            </form>
                        </template>
                        <template v-else>
                            <q-badge
                                class="q-mb-md text-center bg-warning"
                                style="display: block"
                            >
                                {{
                                    $window.translations[
                                        "notification.shift.already_participated"
                                    ] ||
                                    "Du nimmst bereits an dieser Schicht teil"
                                }}
                            </q-badge>
                        </template>
                        <q-btn
                            :href="shift.reservationLink"
                            color="primary"
                            style="width: 100%"
                        >
                            {{
                                $window.translations["common.more_info"] ||
                                "Mehr Infos"
                            }}
                            <template
                                v-if="
                                    !campaign.campaignBookableOnlyForUserHimself
                                "
                            >
                                {{
                                    $window.translations[
                                        "action.or_book_for_others"
                                    ] || "oder für andere buchen"
                                }}
                            </template>
                        </q-btn>
                    </template>
                    <template v-else>
                        <p class="text-center text-red-8">
                            {{
                                $window.translations[
                                    "notification.shift.no_free_places"
                                ] || "Keine freien Plätze mehr"
                            }}
                        </p>
                    </template>
                </q-card-section>
                <q-card-actions align="right">
                    <q-btn
                        flat
                        :label="$window.translations['close'] || 'Schließen'"
                        color="primary"
                        v-close-popup
                    ></q-btn>
                </q-card-actions>
            </q-card>
        </q-dialog>
    </div>
</template>

<script>
import { reactive, computed } from "vue";
import dayjs from "dayjs";

export default {
    props: {
        shift: {
            type: Object,
            required: true,
        },
        user: {
            type: Object,
            required: true,
        },
        csrfToken: {
            type: String,
            required: true,
        },
    },
    setup(props) {
        const modals = reactive({
            warning: false,
            fastMode: false,
        });

        const campaign = computed(() => props.shift.campaign || {});
        const calendar = computed(() => props.shift.calendar || {});

        const linkHref = computed(() => {
            if (
                (props.shift.shouldBeWarnedBecauseOfSecuritySettings &&
                    props.shift.hasFreePlaces) ||
                (campaign.value.fastModeIsActive &&
                    props.shift.hasFreePlaces &&
                    !props.shift.isClosed)
            ) {
                return "javascript:void(0)";
            }

            return props.shift.hasFreePlaces && !props.shift.isClosed
                ? props.shift.reservationLink
                : props.shift.viewReservationsLink;
        });

        const handleLinkClick = (event) => {
            if (
                props.shift.shouldBeWarnedBecauseOfSecuritySettings &&
                props.shift.hasFreePlaces
            ) {
                event.preventDefault();
                modals.warning = true;
            } else if (
                campaign.value.fastModeIsActive &&
                props.shift.hasFreePlaces &&
                !props.shift.isClosed
            ) {
                event.preventDefault();
                modals.fastMode = true;
            }
        };

        const formatTime = (dateTime) => {
            const date = dayjs(dateTime);
            const hourMinute = date.format("HH:mm");
            const key = "t" + hourMinute.replace(":", "");
            if (window.timesTranslations && window.timesTranslations[key]) {
                return window.timesTranslations[key];
            }
            return hourMinute;
        };

        const formatDateTime = (dateTime) => {
            const date = dayjs(dateTime);
            // We use simple format for now as comprehensive localization is hard without full dayjs locale support
            return date.format("DD.MM.YYYY") + " " + formatTime(dateTime);
        };

        const participationPostUrl = computed(
            () => `/schichtteilnahme/${props.shift.id}`,
        );

        const participationLabel = computed(() => {
            const template =
                window.translations["action.i_want_to_join_named"] ||
                "Ich (%s) möchte teilnehmen";
            return template.replace("%s", props.user.firstName);
        });

        return {
            modals,
            campaign,
            calendar,
            linkHref,
            handleLinkClick,
            formatTime,
            formatDateTime,
            participationPostUrl,
            participationLabel,
        };
    },
};
</script>
